import { Router, type IRouter } from "express";
import healthRouter from "./health";
import usersRouter from "./users";
import companiesRouter from "./companies";
import tendersRouter from "./tenders";
import analysesRouter from "./analyses";
import complianceRouter from "./compliance";
import proposalsRouter from "./proposals";
import chatRouter from "./chat";
import plansRouter from "./plans";
import subscriptionsRouter from "./subscriptions";
import invoicesRouter from "./invoices";
import statsRouter from "./stats";
import notificationsRouter from "./notifications";
import reportsRouter from "./reports";
import vendorsRouter from "./vendors";
import savedSearchesRouter from "./savedSearches";
import teamAssignmentsRouter from "./teamAssignments";
import activityRouter from "./activity";
import storageRouter from "./storage";
import adminRouter from "./admin";
import etimadRouter from "./etimad";
import tenderFeaturesRouter from "./tenderFeatures";
import fddRouter from "./fdd";

const router: IRouter = Router();

router.use(healthRouter);
router.use(usersRouter);
router.use(companiesRouter);
router.use(tendersRouter);
router.use(analysesRouter);
router.use(complianceRouter);
router.use(proposalsRouter);
router.use(chatRouter);
router.use(plansRouter);
router.use(subscriptionsRouter);
router.use(invoicesRouter);
router.use(statsRouter);
router.use(notificationsRouter);
router.use(reportsRouter);
router.use(vendorsRouter);
router.use(savedSearchesRouter);
router.use(teamAssignmentsRouter);
router.use(activityRouter);
router.use(storageRouter);
router.use(adminRouter);
router.use(etimadRouter);
router.use(tenderFeaturesRouter);
router.use(fddRouter);

export default router;
